const RemoveIcon = ({ size = 24 }) => {
  return (
    <img
      src={require("../../../assets/images/remove.png")}
      alt="remove"
      width={size}
    />
  );
};

export default RemoveIcon;
